import {BrandImage} from "../../components/brandImage";
import { AccessSelector } from "../../components/accessSelector";
import { PinPad } from "../../components/pinPad";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LuUser } from "react-icons/lu";
import "./style.css";
import { checkPassword, getOrderManager, logIn, setOrderManager } from "../../api/login";
import { BsTv } from "react-icons/bs";

import { setComponentActive, setUserLogged, setManagerConfiguration, setAlert } from "../../reducers/userConfigSlice";
import { saveLoginLS } from "@delibrandev/utils";
import { logout } from "../../api/requests";
import { apiRest } from "../../api/constants";

export const UserSelect = () => {
  const dispatch = useDispatch();
  const logo = useSelector((state) => state.aplicationConfig.corporationData.info?.logo);
  const [menu, setMenu] = useState("");
  const [userData, setUserData] = useState({});
  const [orderManagers, setOrderManagers] = useState([]);
  const [orderManager, updateOrderManager] = useState({});
  const [loginData, updateLoginData] = useState({});

  useEffect(() => {
    logout();
  }, []);

  const getOrderManagers = async () => {
    const response = await getOrderManager();
    if (!response || response.error || !Array.isArray(response.data)) {
      throw new Error("order-managers-unavailable");
    }
    setOrderManagers(response.data.filter((item) => item.assignedUsers?.length));
  };

  const handleUser = async (pinValue) => {
    const payload = {
      userId: userData.userId,
      pin: pinValue,
    };
    const response = await logIn(payload);
    if (response && !response?.error && !response?.data?.error) {
      saveLoginLS({ ...loginData, login: payload }, apiRest);
      dispatch(setUserLogged(true));
      dispatch(setComponentActive("kd"));
      return true;
    } else {
      dispatch(setAlert({ called: true, title: "Error", message: (response?.data?.message || response?.message) === "PIN is not active." ? "El PIN está desactivado. Solicita acceso al administrador." : /access|permited/i.test(response?.data?.message || response?.message || "") ? "No tienes permiso para esta plataforma o puesto." : "Contraseña incorrecta", type: "error" }));
      return false;
    }
  };

  const handlePassword = (pinValue) => {
    return handleMenu("password", pinValue, "orderManager");
  };

  const handleMenu = async (key, data, nextMenu) => {
    //Check password
    if (key === "password") {
      const password = data;
      const payload = {
        password: password,
      };
      const response = await checkPassword(payload);
      if (response && !response.error) {
        updateLoginData({ ...loginData, password: password });
        try {
          await getOrderManagers();
          setMenu(nextMenu);
          return true;
        } catch {
          dispatch(setAlert({ called: true, title: "Gestores no disponibles", message: "No se pudieron cargar los gestores. Vuelve a intentarlo.", type: "error" }));
          return false;
        }
      } else {
        dispatch(setAlert({ called: true, title: "Error", message: "Contraseña incorrecta", type: "error" }));
        return false;
      }
    }

    //Select KD
    if (key === "select-order-manager") {
      const payload = {
        orderManagerConfigurationId: data.orderManagerConfigurationId,
      };
      const response = await setOrderManager(payload);
      if (response && !response.error && !response.data?.error) {
        dispatch(setManagerConfiguration(data));
        updateLoginData({ ...loginData, point: payload });
        updateOrderManager(data);
        setMenu(nextMenu);
      } else {
        throw new Error("order-manager-not-selected");
      }
    }

    //Select User
    if (key === "select-user-manager") {
      setUserData(data);
      setMenu(nextMenu);
    }
  };

  const HandlerMenu = () => {
    let component = <></>;
    if (menu === "orderManager") {
      component = (
        <>
          <AccessSelector
            head={"SELECTOR DE GESTOR"}
            emptyMessage="No hay gestores con usuarios asignados. Revisa la configuración en Admin."
            data={orderManagers}
            icon={<BsTv />}
            callback={(e) => handleMenu("select-order-manager", e, "users")}
            title={"Seleccione el gestor de pedido"}
          />
        </>
      );
    } else if (menu === "users") {
      component = (
        <>
          <AccessSelector
            head={"SELECTOR DE USUARIO"}
            emptyMessage="No hay usuarios asignados a este gestor. Revisa la configuración en Admin."
            data={orderManager.assignedUsers}
            icon={<LuUser />}
            callback={(e) => handleMenu("select-user-manager", e, "pin")}
            title={"Seleccione un usuario"}
          />
        </>
      );
    } else if (menu === "pin") {
      component = <PinPad callback={handleUser} inputText="Ingrese su pin" head={"ACCESO USUARIO"} />;
    } else {
      component = <PinPad allowText callback={handlePassword} inputText="Ingrese la contraseña" head={"ACCESO PLATAFORMA"} />;
    }
    return component;
  };

  return (
    <div className="loginArea">
      <div className="verticalLoginFlex">
        <div className="logoContainer">
          <BrandImage
            src={logo}
            alt="logo"
            className="logoLogin"
          />
        </div>
        {HandlerMenu()}
      </div>
    </div>
  );
};
